import React from "react";
import WcBanyoTemizleyici from "../Components/product/WcBanyoTemizleyici";
import PageHeader from "../Components/common/PageHeader";
import ProductSEO from "../Components/common/ProductSEO";
import { t } from "i18next";

function WcBanyoTemizleyiciPage() {
    return (
        <>
            <ProductSEO
                name="WC & Banyo Temizleyici"
                description="Kireç ve bakteri oluşumunu önleyen, parlak ve hijyenik banyo temizliği sağlayan güçlü formül."
                slug="wcbanyotemizleyici"
                imagePath="assets/images/20-kg/8.webp"
                price={1}
            />
            <PageHeader title={t("WC VE BANYO TEMİZLEYİCİ")} />
            <WcBanyoTemizleyici />
        </>
    );
}

export default WcBanyoTemizleyiciPage;